const doc = [({"da":({"js":({"routes":({"admin":({"translations":({"show":({"the_translation_was_deleted":"Oversættelsen blev slettet."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;